(function() {
    angular.module('emarket.main.navigation')
  .controller('ProfileNavigationController', ['$rootScope', '$scope', 'Auth', function($rootScope, $scope, Auth) {

      var vm = this;
      vm.user = Auth.getUser();
      vm.logout = function() {
          Auth.logout();
          vm.user = null;
      };
      var userChangeEvent = $rootScope.$on(Auth.USER_CHANGE, function() {
          vm.user = Auth.getUser();
      });
      $scope.$on('$destroy', function() {
          userChangeEvent();
      });
  }]);
}());
